<div class="loading-page">
  <div class="counter">
    <p>U2.0 Features Loading...</p>
    <h1>{{ percent }}%</h1>
    <progress [attr.value]="percent" min="0" max="100"></progress>
  </div>
</div>
